import { useTranslation } from "react-i18next"

import MyModal from "@/components/MyModal/MyModal"
import { MODALS } from "@/constants/modals"
import RoundsNotesModal from "@/features/pages/Feedbacks/NotesModal/RoundsNotesModal"

export default function FeedbackModals() {
  const { t } = useTranslation()
  return (
    <>
      <MyModal
        modalName={MODALS.feedbacks.all}
        title={t("feedbackModalTitles.feedbacks")}
      >
        <RoundsNotesModal />
      </MyModal>
    </>
  )
}
